import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const RepeatLast = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();
    
    const { repeatCount, repeatLast } = usePlacementStore(
        useShallow((state) => ({
            repeatCount: state.repeatHistory.length,
            repeatLast: state.repeatLast
        }))
    );

    return (
        <Menu.Item
            disabled={disabled || repeatCount === 0}
            leftSection={<Icon aria-hidden="true" icon="repeat" />}
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralRepeatLast} />}
            onClick={() => repeatLast()}
        >
            {t('repeatLast')}
        </Menu.Item>
    );
};
